import api, { request } from '../../../../../../api';
import { getObjectByIdFromArray } from '../../../../../../contrib/Utils/getObjectByIdFromArray';
import { isError } from '../../../../../../contrib/Utils/isError';
import { ILeaderboard, ILeaderboards, IStateDispatchActions } from '../ContestSetup.context';

export type ISetLeaderboards = (clubId: number, eventId: number, roundId: number) => void;

export const setLeaderboards: IStateDispatchActions<ISetLeaderboards> = (_, dispatch) => async (
  clubId,
  eventId,
  roundId
) => {
  const response: ILeaderboard[] = roundId
    ? await request.get(api.admin.roundLeaderboards(clubId, eventId, roundId))
    : await request.get(api.admin.eventLeaderboards(clubId, eventId));

  if (isError(response)) {
    throw new Error(response.error);
  }

  dispatch({
    type: 'setLeaderboards',
    value: getObjectByIdFromArray(response) as ILeaderboards
  });
};
